// Google Ads ids for Workspace369's own account (customer 367-624-2776, created 2026-10-09).
//
// The site also still loads AW-1001723992, an older tag installed in March 2024 whose
// account nobody on the team can open; it stays until its owner confirms it can go.

export const GOOGLE_ADS_ID = 'AW-18503972521';

// Conversion "Sign-up lead (Start free email)": the Start-free dialog captured an email
// (components/TrialSignupDialog.vue, alongside the GA4 `trial_lead_captured` event).
export const GOOGLE_ADS_SIGNUP_LEAD = `${GOOGLE_ADS_ID}/6ZGBCN63iJcdEKntsPdE`;
